import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Building2, MapPin, Edit2, Eye, X } from "lucide-react";
import BranchDetailsModal from "./BranchDetailModal";

const PreviewCard = ({ branch, onRemove, onEdit }) => {
  const [showDetails, setShowDetails] = useState(false);
  const hasAdditionalDetails =
    branch.district || branch.suburb || branch.landmark || branch.gpsAddress;

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="group relative bg-white rounded-2xl p-5 hover:shadow-lg transition-all duration-300 border border-gray-100"
      >
        <div className="flex items-start gap-4">
          {/* Icon */}
          <div className="w-12 h-12 shrink-0 rounded-2xl bg-[#FF6C6C]/10 flex items-center justify-center">
            <Building2 className="w-6 h-6 text-[#FF6C6C]" />
          </div>

          {/* Content */}
          <div className="min-w-0 flex-1">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <h3 className="font-semibold text-gray-900 truncate pr-4">
                  {branch.name}
                </h3>
                <div className="flex items-center gap-2 mt-0.5">
                  <MapPin className="w-4 h-4 shrink-0 text-[#FF6C6C]" />
                  <span className="text-[#FF6C6C] font-medium truncate">
                    {branch.region}
                  </span>
                </div>
              </div>

              {/* Actions */}
              <div className="flex gap-2 shrink-0">
                {hasAdditionalDetails && (
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => setShowDetails(true)}
                    className="h-8 w-8 flex items-center justify-center rounded-xl bg-gray-100 hover:bg-gray-200 transition-all duration-200"
                  >
                    <Eye className="w-4 h-4 text-gray-600" />
                  </motion.button>
                )}
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => onEdit(branch)}
                  className="h-8 w-8 flex items-center justify-center rounded-xl bg-[#FF6C6C]/10 hover:bg-[#FF6C6C]/20 transition-all duration-200"
                >
                  <Edit2 className="w-4 h-4 text-[#FF6C6C]" />
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => onRemove(branch.branch_slug)}
                  className="h-8 w-8 flex items-center justify-center rounded-xl bg-red-50 hover:bg-red-100 transition-all duration-200"
                >
                  <X className="w-4 h-4 text-[#FF6C6C]" />
                </motion.button>
              </div>
            </div>

            {/* Basic Info */}
            <div className="mt-2 flex items-center gap-2 text-sm text-gray-600">
              <span className="truncate">{branch.location}</span>
              <span className="w-1 h-1 rounded-full bg-gray-300" />
              <span className="truncate">{branch.phoneNumber}</span>
              {hasAdditionalDetails && (
                <span className="text-[#FF6C6C]/60 text-xs">
                  • More details available
                </span>
              )}
            </div>
          </div>
        </div>
      </motion.div>

      <AnimatePresence>
        {showDetails && (
          <BranchDetailsModal
            branch={branch}
            isOpen={showDetails}
            onClose={() => setShowDetails(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
};
export default PreviewCard;